<template>
    <div v-if="off"><slot /></div>
    <transition-group
        v-else-if="group === true"
        :enter-active-class="$style['fade-n-slide-enter-active' + mult]"
        :leave-active-class="$style['fade-n-slide-leave-active' + mult]"
        :enter-class="$style['fade-n-slide-enter']"
        :leave-to-class="$style['fade-n-slide-leave-to']"
        :class="classes"
        @enter="enter"
        @after-enter="afterEnter"
        @leave="leave"
        :mode="mode"
        :tag="tag"
    >
        <slot />
    </transition-group>
    <transition
        v-else
        :enter-active-class="$style['fade-n-slide-enter-active' + mult]"
        :leave-active-class="$style['fade-n-slide-leave-active' + mult]"
        :enter-class="$style['fade-n-slide-enter']"
        :leave-to-class="$style['fade-n-slide-leave-to']"
        :class="classes"
        @enter="enter"
        @after-enter="afterEnter"
        :mode="mode"
        @leave="leave"
    >
        <slot />
    </transition>
</template>

<style module lang="scss">
@mixin active-transition($time) {
    transition: opacity $time, height $time, width $time, margin $time,
        padding $time;
    overflow: hidden;
}
.fade-n-slide-enter-active,
.fade-n-slide-leave-active {
    $time: 0.5s;
    @include active-transition($time);

    &--x2 {
        @include active-transition(calc($time / 2));
    }
    &--x3 {
        @include active-transition(calc($time / 3));
    }
    &--x4 {
        @include active-transition(calc($time / 3));
    }
    &--x5 {
        @include active-transition(calc($time / 3));
    }
}

.height-enabled.fade-n-slide-enter,
.height-enabled.fade-n-slide-leave-to {
    height: 0;
    margin-top: 0;
    margin-bottom: 0;
    padding-top: 0;
    padding-bottom: 0;
}

.width-enabled.fade-n-slide-enter,
.width-enabled.fade-n-slide-leave-to {
    width: 0;
    margin-left: 0;
    margin-right: 0;
    padding-left: 0;
    padding-right: 0;
}

.fade-n-slide-enter,
.fade-n-slide-leave-to {
    opacity: 0;
}
</style>

<script>
export default {
    name: "fade-and-slide",
    props: {
        speedMultiplier: Number,
        group: {
            type: Boolean,
            default: false,
        },
        off: {
            type: Boolean,
            default: false,
        },
        width: {
            type: Boolean,
            default: false,
        },
        height: {
            type: Boolean,
            default: true,
        },
        tag: {
            type: String,
            default: "span",
        },
        mode: {
            type: String,
            default: "in-out",
        },
    },
    computed: {
        classes() {
            const result = [];
            if (this.width === true) result.push(this.$style["width-enabled"]);
            if (this.height === true)
                result.push(this.$style["height-enabled"]);
            return result;
        },
        mult() {
            if (this.speedMultiplier == null || this.speedMultiplier == 1) {
                return "";
            }
            return "--x" + this.speedMultiplier;
        },
    },
    methods: {
        enter(element) {
            element.style.width = getComputedStyle(element).width;
            element.style.position = "absolute";
            element.style.visibility = "hidden";
            if (this.height === true) element.style.height = "auto";
            if (this.width === true) element.style.width = "auto";

            const computedStyle = getComputedStyle(element);

            let height;
            let width;
            let marginLeft;
            let marginRight;
            let marginTop;
            let marginBottom;
            let paddingLeft;
            let paddingRight;
            let paddingTop;
            let paddingBottom;

            if (this.height === true) {
                height = computedStyle.height;

                marginTop = computedStyle.marginTop;
                marginBottom = computedStyle.marginBottom;

                paddingTop = computedStyle.paddingTop;
                paddingBottom = computedStyle.paddingBottom;
            }
            if (this.width === true) {
                width = computedStyle.width;

                marginLeft = computedStyle.marginLeft;
                marginRight = computedStyle.marginRight;

                paddingLeft = computedStyle.paddingLeft;
                paddingRight = computedStyle.paddingRight;
            }

            element.style.position = "";
            element.style.visibility = "";
            if (this.height === true) {
                element.style.height = 0;

                element.style.marginTop = 0;
                element.style.marginBottom = 0;

                element.style.paddingTop = 0;
                element.style.paddingBottom = 0;
            }
            if (this.width === true) {
                element.style.width = 0;

                element.style.marginLeft = 0;
                element.style.marginRight = 0;

                element.style.paddingLeft = 0;
                element.style.paddingRight = 0;
            }

            if (this.height === true) getComputedStyle(element).height;
            if (this.width === true) getComputedStyle(element).width;

            setTimeout(() => {
                if (this.height === true) {
                    element.style.height = height;

                    element.style.marginTop = marginTop;
                    element.style.marginBottom = marginBottom;

                    element.style.paddingTop = paddingTop;
                    element.style.paddingBottom = paddingBottom;
                }
                if (this.width === true) {
                    element.style.width = width;

                    element.style.marginLeft = marginLeft;
                    element.style.marginRight = marginRight;

                    element.style.paddingLeft = paddingLeft;
                    element.style.paddingRight = paddingRight;
                }
            });
        },
        afterEnter(element) {
            if (this.height === true) element.style.height = "auto";
            if (this.width === true) element.style.width = "auto";
        },
        leave(element) {
            const computedStyle = getComputedStyle(element);
            if (this.height === true) {
                element.style.height = computedStyle.height;

                element.style.marginTop = computedStyle.marginTop;
                element.style.marginBottom = computedStyle.marginBottom;

                element.style.paddingTop = computedStyle.paddingTop;
                element.style.paddingBottom = computedStyle.paddingBottom;
            }
            if (this.width === true) {
                element.style.width = computedStyle.width;

                element.style.marginLeft = computedStyle.marginLeft;
                element.style.marginRight = computedStyle.marginRight;

                element.style.paddingLeft = computedStyle.paddingLeft;
                element.style.paddingRight = computedStyle.paddingRight;
            }

            if (this.height === true) {
                getComputedStyle(element).height;
            }
            if (this.width === true) {
                getComputedStyle(element).width;
            }

            setTimeout(() => {
                if (this.height === true) {
                    element.style.height = 0;

                    element.style.marginTop = 0;
                    element.style.marginBottom = 0;

                    element.style.paddingTop = 0;
                    element.style.paddingBottom = 0;
                }
                if (this.width === true) {
                    element.style.width = 0;

                    element.style.marginLeft = 0;
                    element.style.marginRight = 0;

                    element.style.paddingLeft = 0;
                    element.style.paddingRight = 0;
                }
            });
        },
    },
};
</script>
